import { AdminNotificationType, UserRole } from '../../enums';

export interface SendNotificationDto {
  title: string; // Required, max 200
  message: string; // Required, max 1000
  notificationType: AdminNotificationType;
  targetRoles: UserRole[];
  specificUserIds?: string[]; // Guid[]
  facilityIds?: string[]; // Guid[]
  scheduledDate?: string | null; // DateTime as ISO string
  isUrgent?: boolean;
  actionButtonText?: string | null; // Max 100
  actionUrl?: string | null; // Max 200
}
